backgroundStyleProp = require 'utils/background-style-prop'
transliterate = require('utils/transliterate-snippet')
###
# Модель черновой категории
###
App.DraftCategory = DS.Model.extend
  # store: Em.inject.service('store')

  menu_order    : DS.attr 'number'
  is_hidden     : DS.attr 'boolean'
  is_list       : DS.attr 'boolean'
  is_stealthy   : DS.attr 'boolean'
  export_hidden_sources : DS.attr 'string'
  menu_order    : DS.attr 'number'
  name          : DS.attr 'string'
  external_id   : DS.attr 'string'
  comment       : DS.attr 'string'
  photo         : DS.attr 'mixed'
  age_restriction         : DS.attr 'boolean'

  toggle_hidden_recursively     : DS.attr 'boolean'
  toggle_hidden_restaurant_id   : DS.attr 'number'
  toggle_hidden                 : DS.attr 'boolean'
  disabled_sources              : DS.attr 'string'

  # meta
  meta_title         : DS.attr 'string'
  meta_description   : DS.attr 'string'
  
  #SEO
  slug: DS.attr 'string'

  # Внешние связи
  draft_dishes : DS.hasMany   'draft_dish',   async: true
  organization : DS.belongsTo 'organization', async: true

  parent           : DS.belongsTo 'draft_category', async: false, inverse: 'draft_categories'
  draft_categories : DS.hasMany   'draft_category',   async: true, inverse: 'parent'


  slugIsChangedManual: false

  nameObserver: (->
    sluggedName = transliterate.slugify(@get('name'))
    slug = @get('slug')
    if @get('isNew') and not @get('slugIsChangedManual')
      @set('slug', sluggedName)
  ).observes('name')

  slugObserver: (->
    sluggedName = transliterate.slugify(@get('name'))
    slug = @get('slug')
    return unless slug
    if sluggedName != slug
      @set('slugIsChangedManual', true)
      @set('slug', transliterate.slugify(@get('slug')))
  ).observes('slug')

  photoPlaceholder: 'images/draft-dish-placeholder.png'
  safePhotoSmall: (->
    @get('photo.small_square') or @get('photoPlaceholder')
  ).property('photo.small_square')
  photoSmallBackground: backgroundStyleProp('safePhotoSmall')

  export_hidden_sources_array: ((key, value, oldValue)->
    if arguments.length == 1
      return [] unless @get('export_hidden_sources')
      return @get('export_hidden_sources').split(',')
    else
      @set 'export_hidden_sources', value.join(',')
      return value
  ).property('export_hidden_sources')

  name_with_level: (->
    "#{'     '.repeat(@get('level'))}#{@get('name')}"
  ).property('name','level')

  level: (->
    level = 0
    v = @get('parent')
    while v
      v = v.get('parent')
      level += 1
    level
  ).property('parent', 'parent.parent', 'parent.parent.parent', 'parent.parent.parent.parent', 'parent.parent.parent.parent.parent')

  is_root: Em.computed.not('parent')

  disabled_sources_array: ((key, value, oldValue)->
    if arguments.length == 1
      return [] unless @get('disabled_sources')
      return @get('disabled_sources').split(',')
    else
      @set 'disabled_sources', value.join(',')
      return value
  ).property('disabled_sources')

  uploadPhoto: (file) ->
    promise = @fileUpload('photo', file)
    promise.then => @notifyRecordChange()
    promise

  reorder: (target_id) ->
    @nonRESTAction('PUT', 'reorder', { target_id})
    .then =>
      # @store.getById('draft_category', target_id).reload()
      # @reload()
      # @notifyRecordChange()
